export const categories = [
  {
    name: 'Energética Score',
    count: '50+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/7ef23c395fd4e48b9f143c6ea1dc6ece.png'
  },
  {
    name: 'Gaseosas',
    count: '80+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/11913ab2c74cae7fc9c37e8f3957c96b.png'
  },
  {
    name: 'Abarrotes',
    count: '120+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/e95f9d9b44ab196ab222db864138399b.png'
  },
  {
    name: 'Papel Higiénico y Toalla Nova',
    count: '60+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/4680d87e524fded176fe83e474dca53c.png'
  },
  {
    name: 'Agua',
    count: '90+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/155526db34942cb5fd2c8950dc00e568.png'
  },
  {
    name: 'Bebidas Isotónicas',
    count: '40+',
    image: 'https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/8868c3cfb97a9eb4cc903522e3c62ba8.png'
  }
];
